import plangridTrackEvents, { trackEvent } from "./amplitudeInit-vanilla";

const addContactFormHandler = () => {
  const formWrapper = document.querySelector(".contact-box");
  const contactForm = document.querySelector('form[name="contact"]');
  const submitBtn = formWrapper.querySelector("button");

  const submitContactForm = () => {
    const marketoContact = MktoForms2.getForm(1091);
    submitBtn.setAttribute("disabled", "disabled");

    marketoContact.onSuccess((values, followUpUrl) => {
      formWrapper.classList.add("confirmation");
      trackEvent("public_web.page.engage.start", { from: "contact" });
      return false;
    });

    marketoContact.setValues({
      FirstName: contactForm["first-name"].value,
      LastName: contactForm["last-name"].value,
      Email: contactForm.email.value,
      Company: contactForm.company.value,
      Phone: contactForm.phone.value,
      commentCapture: contactForm.message.value,
    });

    marketoContact.submit();
  };

  contactForm.addEventListener("submit", e => {
    e.preventDefault();

    submitContactForm();
  });
};

const init = () => {
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1091);
  plangridTrackEvents("contact");
  addContactFormHandler();
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/contact.js